import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountTypes } from '@interfaces/models/account-types';
import { Store } from '@ngrx/store';
import { GiftingDesignationTypes } from '@shared/models';
import { EnableFeatureToggles } from '@store/actions/feature/feature.actions';
import * as fromRootStore from '@store/index';
import { Subscription } from 'rxjs';

/**
 * Define a type to make evaluating the query easier.
 @param {string} accountType - Account type inheriting
 @param {string} client - Client
 @param {string} features - Feature(s) that will be enabled
 @param {string} flowType - The flow type
 @param {string} individualDesignation - Individual designation
 @param {string} IRADesignation - IRA designation
 @param {string} relationship - Relationship to decedent SPOUSE or NONSPOUSE
 */

export interface AppQueryParameters {
  accountType: string;
  client?: string;
  features?: string[];
  flowType: string;
  individualDesignation?: string;
  giftingDesignation?: GiftingDesignationTypes;
  IRADesignation?: string;
  relationship?: string;
  accountFromType?: AccountTypes;
  accountToType?: AccountTypes;
}

@Injectable({
  providedIn: 'root',
})
export class QueryHandlerService implements OnDestroy {
  subs: Subscription = new Subscription();

  constructor(
    private globalStore: Store<fromRootStore.State>,
    private route: ActivatedRoute,
  ) {
    this.initializeHandlers();
  }

  processFeatures(features: string[]) {
    const enabledFeatures = features ? features : [];
    if (enabledFeatures.length > 0) {
      this.globalStore.dispatch(EnableFeatureToggles({ payload: enabledFeatures }));
    }
  }

  /**
   * ngOnInit didn't seem to get called therefore using initialize method instead.
   * Subscribes to the current route query parameters and updates store accordingly.
   */
  initializeHandlers() {
    this.subs.add(
      this.route.queryParams.subscribe((params) => {
        const featuresParameters =
          typeof params.features === 'string' ? params.features.split(' ') : params.features;
        this.processFeatures(featuresParameters);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
